/**
 * FX3 C11 — a user who merely lacks a permission used to see the misleading toast
 * "DP module is not enabled", and the page frame rendered behind it anyway
 * (UI issues 5, 6, 14, 15). AccessBlocked replaces the body instead.
 *
 * FX3b item 8 — the server's own 403 text carries raw permission keys
 * ("... — dp.partners.view required"). Nobody outside engineering can read that, so a
 * permission failure now always shows one plain-English sentence. A switched-off module
 * is a different situation and keeps its own wording.
 */
import { Lock, PowerOff } from "lucide-react";

const NO_ACCESS_LINE = "You don't have access to this screen. Ask an Admin to give you access.";

export const AccessBlocked = ({ detail, testid = "access-blocked" }) => {
  const text = typeof detail === "string" ? detail : "";
  const moduleOff = /is not enabled|is switched off|module is off/i.test(text);
  const Icon = moduleOff ? PowerOff : Lock;
  return (
    <div className="border border-dashed border-zinc-300 rounded-sm py-14 px-6 text-center" data-testid={testid}>
      <Icon className="w-6 h-6 mx-auto text-zinc-400" />
      <p className="mt-3 text-sm font-medium text-zinc-700" data-testid={`${testid}-title`}>
        {moduleOff ? "This module is switched off" : "You don't have access to this screen"}
      </p>
      <p className="mt-1 text-xs text-zinc-500 max-w-md mx-auto" data-testid={`${testid}-detail`}>
        {moduleOff ? text : "Ask an Admin to give you access."}
      </p>
      {moduleOff && (
        <p className="mt-3 text-[11px] text-zinc-400">
          An Admin can switch it on in Admin → Settings → Feature Flags.
        </p>
      )}
    </div>
  );
};

export { NO_ACCESS_LINE };
